import { Modal } from 'antd';

export const confirmLeaveWithoutSaving = (reason: string, onLeave: () => void) =>
  Modal.confirm({
    title: 'Leave without saving?',
    content: `${reason} Your unsaved changes will be lost when you leave this page.`,
    okText: 'Leave without saving',
    cancelText: 'Keep editing',
    onOk: onLeave,
  });
